import { useCallback, useState } from "react";

/**
 * 수정 폼의 "변경 사항 있음(dirty)" 여부 추적 훅.
 *
 * 서버에서 불러온 초기값을 captureBaseline(snapshot)으로 기록해 두고, 현재 값
 * 스냅샷과 비교한다. 한 필드라도 다르면 isDirty=true.
 *
 * 사용법:
 *   const current = { title, hide, start, end, ... };           // 매 렌더 계산
 *   const { isDirty, captureBaseline } = useDirtyCheck(current);
 *   // 데이터 로드 후: captureBaseline({ title, hide, start, end, ... });
 *   // 제출 버튼 활성: isAllDataFilled() && isDirty
 *
 * 주의: 스냅샷 값은 원시값(문자열/불리언/숫자)으로 정규화해서 넘긴다.
 * null/undefined/"" 를 동일 취급하려면 호출부에서 `value || ""` 식으로 맞춘다.
 *
 * @param {Record<string, unknown>} currentValues - 현재 폼 값 스냅샷.
 */
export function useDirtyCheck(currentValues) {
  const [baseline, setBaseline] = useState(null);

  const captureBaseline = useCallback((snapshot) => {
    setBaseline(snapshot);
  }, []);

  const isDirty = baseline
    ? Object.keys(baseline).some(
        (key) => !Object.is(baseline[key], currentValues[key]),
      )
    : false;

  return { isDirty, captureBaseline, hasBaseline: baseline !== null };
}

export default useDirtyCheck;
